export default function NeonTrailsIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <rect x="5" y="5" width="54" height="54" rx="4" fill="none" stroke="#3B434F" strokeWidth="3" />
      <path d="M12 52V22h20v-8" fill="none" stroke="#2F8BFF" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M52 12v30H38v10" fill="none" stroke="#FF8A1F" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="32" cy="14" r="4" fill="#E7ECF3" />
      <path d="M38 47l4 5-4 5-4-5z" fill="#E7ECF3" />
    </svg>
  );
}
